<template>
  <div class="customise-item" style="display: block;" @click="toolTipClick()">
    <div class="customise-item-details">
      <div class="extra-items-wrapper">
        <div class="container item-details">
          <div class="row">
            <div class="col-12">
              <h3 class="fontColorBlack">{{ product.Name }}</h3>
              <p class="s-description fontColorBlack" v-html="product.ShortDescription"></p>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="From Name">{{ $t('message.fromName') }}</label>
              <input
                id="FromName"
                v-model="messageModel.From"
                name="fromName"
                type="text"
                @change="fixQuantity()"
                class="form-control"
              />
              <div
                class="invalid-feedback"
              >{{ OOErrors.first("fromName") | inputNameLocale("fromName")}}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="ToField">{{ $t('message.toName') }}</label>
              <input
                id="ToField"
                v-model="messageModel.To"
                name="toName"
                type="text"
                @change="fixQuantity()"
                class="form-control"
              />
              <div
                class="invalid-feedback"
              >{{ OOErrors.first("toName") | inputNameLocale("toName")}}</div>
            </div>
            <div class="form-group col-md-6">
              <label for="Email">{{ $t('message.giftEmail') }}</label>
              <img
                id="giftHelpImage"
                v-bind:title="getToolTipMessage"
                class="toolTipIcon"
                @click="showToolTip()"
                :src="getToolTipIcon()"
                alt="toolTipIcon"
              />
              <span
                id="toolTipSpan"
                v-if="isShowToolTip"
                class="tooltiptext"
              >{{ $t('message.giftEmailToolTipMessage') }}</span>
              <input
                v-validate="'required|email'"
                id="Email"
                v-model="messageModel.Email"
                @change="fixQuantity()"
                name="giftEmailToolTipMessage"
                type="text"
                class="form-control"
              />
              <div
                class="invalid-feedback"
              >{{ OOErrors.first("Email") | inputNameLocale("giftEmailToolTipMessage") }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="Message">{{ $t('message.message') }}</label>
              <textarea
                id="Message"
                v-model="messageModel.Message"
                name="message"
                class="form-control"
              />
              <div
                class="invalid-feedback"
              >{{ OOErrors.first("message") | inputNameLocale("message") }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="w-100 pb-4 pt-2 d-flex justify-content-center">
              <button
                :disabled="quantity <= 1"
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                @click="dec"
              >
                <span class="bigger-material-icons material-icons">remove_circle_outline</span>
              </button>
              <span class="px-4 d-flex align-items-center">
                <strong class="fontColorBlack">{{ quantity }}</strong>
              </span>
              <button
                class="btn-white btn-circle d-flex justify-content-center align-items-center"
                @click="inc"
              >
                <span class="bigger-material-icons material-icons">add_circle_outline</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <footer class="extras-footer">
        <button
          type="button"
          class="btn btn-cancel"
          style="width: 30%; background: rgb(52, 54, 214); border: 0; color: rgb(255, 255, 255)"
          @click="closeModalMobile()"
        >{{$t("message.cancel")}}</button>
        <button
          type="button"
          class="btn btn-primary"
          style="width: 70%; opacity: 0.85; background: rgb(52, 54, 214); border: 0; color: rgb(255, 255, 255)"
          @click="addToCartMobile()"
        >
          <span
            style="float:left;"
          >{{ $t('message.addToCart') }}</span>
          <span
            style="float:right; margin-right: 2px"
          >{{ totalPrice | formatMoney(currencySign) }}</span>
          <!-- <span v-else style="float:right;">{{ $t('message.maximumQuantityExceeded') }}</span> -->
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/giftcard/details";
export default {
  name: "DetailsPopup",
  props: {
    product: {
      type: Object,
      default: () => {}
    },

    price: {
      type: Number,
      default: 0
    },
    productId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isShowToolTip: false,
      quantity: 1,
      // maxItemQuantity: 20,
      messageModel: {
        From: "",
        To: "",
        Message: "",
        Email: ""
      }
    };
  },
  computed: {
    ...shared.computed,
  },
  methods: {
    ...shared.methods
  }
};
</script>
